import axiosInstance from '../../setup/axios/axiosInstance'
import {API_URL, accessAllowOrigin} from '../helpers/helpers'

export const GET_USERAPPLICATIONS_URL = `${API_URL}/userapplications`
export async function getUserApplications(token: string) {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      ClientId: '1CAA63AA-45ED-48AE-8572-F7E9BDDAA3EF',
      'Access-Control-Allow-Origin': `${accessAllowOrigin}`,

      'Accept-Language': 'ba',
    },
  }

  return await axiosInstance.get(GET_USERAPPLICATIONS_URL, config)
}
